import React from 'react'

const SearchInputNosto = ({
    value,
    onChange,
    onSearch,
    onInput,
    suggestions = [],
    onSuggestionClick,
    placeholder = 'Search',
    className = '',
    onClick,
    ref,
}) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()

            // Search submission tracking is handled by the parent component
            // to avoid duplicate events and ensure proper deduplication
            onSearch()
        }
    }

    const handleClear = () => {
        onChange('')
        if (onInput) onInput('')
    }

    return (
        <div className="search-container relative w-full">
            <input
                type="text"
                id="searchInput"
                placeholder={value ? '' : placeholder}
                className={`search-input items-center h-9 bg-background-secondary-subtle rounded-full pl-10 font-akkurat !font-normal ${value ? 'pr-16' : 'pr-3'} ${className}`}
                value={value}
                onChange={(e) => {
                    onChange(e.target.value)
                    if (onInput) onInput(e.target.value)
                }}
                onKeyDown={handleKeyDown}
                onClick={onClick}
                autoComplete="off"
                ref={ref}
            />
            {value && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-primary font-normal text-sm underline cursor-pointer z-10 bg-transparent"
                >
                    Clear
                </button>
            )}
            {suggestions.length > 0 && (
                <ul className="absolute top-full left-0 w-full bg-white border border-oat mt-1 rounded shadow-lg z-10 max-h-52 overflow-y-auto">
                    {suggestions.map((s, i) => (
                        <li
                            key={i}
                            className="p-2 hover:bg-[#EFEFEF] cursor-pointer text-black"
                            onClick={() => {
                                // Suggestion click tracking is handled by the parent component
                                // to avoid duplicate events and ensure proper deduplication
                                onSuggestionClick(s)
                            }}
                        >
                            {s}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchInputNosto
